// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37sz7","colBig":"styles_colBig___pj27","colSmall":"styles_colSmall__2RWMr"};